/* Development-store candidate. No persistence or customer data logging. */
(function () {
  'use strict';
  const selector = '[data-wcf-measure]';
  const fields = root => Array.from(root.querySelectorAll('[data-measure-field]'));
  const expected = ['Height (feet & inches)','Weight (pounds)','Bust (inches)','Waist (inches)','Hip Circumference (inches)','Upper Arm Circumference (inches)','Inseam (inches)','Outseam (inches)','Shoulder Width (inches)','Crotch Length (inches)','Sizes of set worn in the past','Scrub Set preferences','Scrub Set preferences'];
  function evaluate(root) {
    const controls=fields(root);
    if (controls.length !== expected.length || controls.some((x,i)=>x.dataset.label!==expected[i] || x.name!==`properties[${expected[i]}]`) || controls.slice(0,7).some(x=>x.dataset.required!=='true') || controls[11].value!=='Loose-fitting' || controls[12].value!=='Slim-fit cut') return {ok:false,text:'',message:'Measurements are unavailable. Please refresh and try again.'};
    const lines = [], groups = new Map();
    for (const input of controls) {
      const label = input.dataset.label;
      if (input.type === 'checkbox') {
        if (input.checked) groups.set(label, [...(groups.get(label) || []), input.value]);
        continue;
      }
      const value = input.value.trim();
      if (input.dataset.required === 'true' && !value) return {ok:false, text:'', message:`Please enter ${label}.`, field:input};
      if (input.validity?.badInput || input.validity?.rangeUnderflow || input.validity?.rangeOverflow || input.validity?.stepMismatch || input.validity?.tooLong) {
        let message = `Please check ${label}.`;
        if (input.validity.rangeUnderflow) message = `${label} must be at least ${input.min}.`;
        if (input.validity.rangeOverflow) message = `${label} must be no more than ${input.max}.`;
        if (input.validity.tooLong) message = `${label} must be ${input.maxLength} characters or fewer.`;
        return {ok:false, text:'', message, field:input};
      }
      // Browsers enforce maxlength interactively; also check values set by scripts.
      if (input.maxLength >= 0 && value.length > input.maxLength) return {ok:false,text:'',message:`${label} must be ${input.maxLength} characters or fewer.`,field:input};
      if (value) lines.push(`${label}: ${value}`);
    }
    for (const [label, values] of groups) lines.push(`${label}: ${values.join(', ')}`);
    return {ok:true,text:lines.join('\n'),message:''};
  }
  function setup(root) {
    if (root.dataset.measureReady === 'true') return;
    const dialog=root.querySelector('[data-measure-dialog]'),open=root.querySelector('[data-measure-open]'),error=root.querySelector('[data-measure-error]');
    if (!dialog || !open || !error) return;
    root.dataset.measureReady='true';
    let snapshot=fields(root).map(x=>({value:x.value,checked:x.checked}));
    const clear=()=>{error.hidden=true;error.textContent='';fields(root).forEach(x=>x.removeAttribute('aria-invalid'));};
    const show=()=>{if(!dialog.open)dialog.showModal();};
    const restore=()=>fields(root).forEach((x,i)=>{x.value=snapshot[i].value;x.checked=snapshot[i].checked;});
    const cancel=()=>{restore();clear();if(dialog.open)dialog.close();open.focus();};
    const focusError=result=>{show();clear();error.textContent=result.message;error.hidden=false;if(result.field){result.field.setAttribute('aria-invalid','true');result.field.focus();}else error.focus();};
    root._wcfMeasure={show,focusError};
    // Move the existing mounted entry; retain its dialog, listeners and state.
    const product=root.closest('product-info[data-wcf-personalize-preview]');
    if (product && root.closest('product-form[data-wcf-sandbox-measure-required]')) {
      const arrange=()=>{
        if (product.querySelectorAll('[data-wcf-measure]').length !== 1) return;
        const entries=product.querySelectorAll('.wcf-preview-standalone');
        if (entries.length > 1) return;
        const entry=entries[0];
        if (entry && entry.previousElementSibling !== root) root.insertAdjacentElement('afterend',entry);
        const video=root.querySelector(':scope > .wcf-video-open');
        if (video && video.nextElementSibling !== open) root.insertBefore(video,open);
      };
      arrange();
      new MutationObserver(arrange).observe(product,{childList:true,subtree:true});
    }
    open.addEventListener('click',()=>{snapshot=fields(root).map(x=>({value:x.value,checked:x.checked}));clear();show();});
    root.querySelector('[data-measure-cancel]').addEventListener('click',cancel);
    dialog.addEventListener('cancel',event=>{event.preventDefault();cancel();});
    dialog.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.tagName==='INPUT'&&event.target.type!=='checkbox'){event.preventDefault();}});
    root.querySelector('[data-measure-save]').addEventListener('click',()=>{const result=evaluate(root);if(!result.ok){focusError(result);return;}snapshot=fields(root).map(x=>({value:x.value,checked:x.checked}));clear();dialog.close();open.textContent='Edit measurements';open.focus();});
    root.addEventListener('input',event=>{if(event.target.matches('[data-measure-field]')){event.target.removeAttribute('aria-invalid');error.hidden=true;error.textContent='';}});
  }
  function read(form) {
    const root=form?.querySelector(selector);if(!root)return {ok:false,text:'',message:'Measurements are unavailable.'};
    setup(root);const result=evaluate(root);if(!result.ok)root._wcfMeasure?.focusError(result);
    return {ok:result.ok,text:result.text,message:result.message};
  }
  window.wcfSandboxMeasurements={read};
  const init=()=>document.querySelectorAll(selector).forEach(setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
